import { useContext, useEffect } from 'react'

import { Box, Image } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'

import { AuthContext } from '../../contexts/auth'
import { getFilteredRoutes } from '../../utilities/menu/user-has-permission'

import { BlockchainCard } from './components/BlockchainCard/blockchain-card.comp'
import { SidebarItem } from './components/SidebarItem/sidebar-item.comp'
import { Tutorial } from './components/Tutorial/tutorial.comp'
import { UserAvatar } from './components/UserAvatar/user-avatar.comp'
import * as Styles from './sidebar.styles'
import { SidebarProps } from './sidebar.types'

export const Sidebar = ({ open, onClose }: SidebarProps) => {
  const { user, userType } = useContext(AuthContext)

  const navigate = useNavigate()

  const filteredRoutes = userType
    ? getFilteredRoutes(user).filter((route) => route.sidebar)
    : []

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (open && onClose && event.target) {
        const target = event.target as HTMLElement

        if (!target.closest('#sidebar')) {
          onClose()
        }
      }
    }

    if (open) {
      const timeoutId = setTimeout(() => {
        document.addEventListener('click', handleClickOutside)
      }, 0)

      return () => {
        clearTimeout(timeoutId)
        document.removeEventListener('click', handleClickOutside)
      }
    } else {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [open, onClose])

  const handleOnClickItem = (index: number) => {
    const { url } = filteredRoutes[index]

    onClose()
    navigate(url!)
  }

  return (
    <Styles.SidebarWrapper
      id="sidebar"
      direction="column"
      height="100vh"
      alignItems="center"
      open={open}
      paddingY={2}
    >
      <Box
        width="210px"
        height="60px"
        alignItems="center"
        justifyContent="center"
      >
        <Image
          src="/assets/white-logo.svg"
          alt="Sidebar"
          width="150px"
          height="auto"
          objectFit="cover"
        />
      </Box>
      <Box
        marginTop={2}
        direction="column"
        gap={1}
        width="100%"
        justifyContent="space-between"
        alignItems="center"
        flex={1}
        paddingX={2}
      >
        <Box width="100%" direction="column" gap={1}>
          <Box direction="column" width="100%">
            {filteredRoutes.map((item, index) => (
              <SidebarItem
                key={`sidebar-item-${index}`}
                onClick={() => handleOnClickItem(index)}
                {...item}
              />
            ))}
          </Box>
          <BlockchainCard />
        </Box>
        <Box width="100%">
          <Styles.SidebarFooter
            direction="column"
            width="100%"
            gap={2}
            paddingTop={3}
          >
            <Tutorial />
            <UserAvatar />
            <Box marginTop={2} justifyContent="center" width="100%">
              <Styles.SidebarFooterText align="center" color="grey_4">
                FairFashion
              </Styles.SidebarFooterText>
            </Box>
          </Styles.SidebarFooter>
        </Box>
      </Box>
    </Styles.SidebarWrapper>
  )
}
